<template>
  <div>
    <ed-cliente  :intId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdCliente from "@/components/cliente/editar";
export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdCliente },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "suporte.cliente" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>